<div class="container">
    <p>{{"AbpAccount::DisplayName:Version" | abpLocalization}}</p>
    <p>{{version()}}</p>
</div>
